import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import { deleteQuoteProduct } from "../apis/deleteQuoteProduct";

export const useDeleteQuoteProduct = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, number>({
        mutationFn: deleteQuoteProduct,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
